// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PagesSettings_pagesContainer__eYBeL {
  padding-top: 6rem;
  padding-bottom: 4rem;
  max-width: 1200px;
  margin: 0 auto;
}

.PagesSettings_header__7aGy3 {
  margin-bottom: 2rem;
  color: #fff;
}

.PagesSettings_tabContainer__SBthX {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #e1e1e1;
}

.PagesSettings_tabButton__Mf0pA {
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: #fff;
  position: relative;
  transition: all 0.3s ease;
  /* border: 2px solid #000; */
}

.PagesSettings_tabButton__Mf0pA:hover {
  background-color: #E50914;
  color: #fff;
}

.PagesSettings_activeTab__C85L4 {
  color: #fff;
}

.PagesSettings_activeTab__C85L4::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #E50914;
}

.PagesSettings_tabPanel__FLQJE {
  display: none;
}

.PagesSettings_activePanel__\\+TnBb {
  display: block;
}

.PagesSettings_editorContainer__ZQ7Nk {
  margin-top: 1rem;
}

.PagesSettings_editorLabel__0Zh-t {
  display: block;
  margin-bottom: 1rem;
  font-weight: 500;
  color: #fff;
}

.PagesSettings_actionButtons__cKKre {
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.PagesSettings_saveButton__8tzRL {
  padding: 0.75rem 1.5rem;
  background-color: #E50914;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.PagesSettings_saveButton__8tzRL:hover {
  background-color: #cc0812;
}

.PagesSettings_cancelButton__wdd7Z {
  padding: 0.75rem 1.5rem;
  background-color: #fff;
  color: #000;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.PagesSettings_cancelButton__wdd7Z:hover {
  background-color: #f5f5f5;
}

/* Custom styles for Jodit editor */
.PagesSettings_editorWrapper__7jexn .jodit-toolbar-button {
  color: #000;
}

.PagesSettings_editorWrapper__7jexn .jodit-toolbar-button:hover {
  color: #E50914;
}

.PagesSettings_editorWrapper__7jexn .jodit-workplace {
  border: 1px solid #e1e1e1;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/PagesSettings.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".pagesContainer {\n  padding-top: 6rem;\n  padding-bottom: 4rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.header {\n  margin-bottom: 2rem;\n  color: #fff;\n}\n\n.tabContainer {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #e1e1e1;\n}\n\n.tabButton {\n  padding: 0.75rem 1.5rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: #fff;\n  position: relative;\n  transition: all 0.3s ease;\n  /* border: 2px solid #000; */\n}\n\n.tabButton:hover {\n  background-color: #E50914;\n  color: #fff;\n}\n\n.activeTab {\n  color: #fff;\n}\n\n.activeTab::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #E50914;\n}\n\n.tabPanel {\n  display: none;\n}\n\n.activePanel {\n  display: block;\n}\n\n.editorContainer {\n  margin-top: 1rem;\n}\n\n.editorLabel {\n  display: block;\n  margin-bottom: 1rem;\n  font-weight: 500;\n  color: #fff;\n}\n\n.actionButtons {\n  margin-top: 2rem;\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.saveButton {\n  padding: 0.75rem 1.5rem;\n  background-color: #E50914;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n}\n\n.saveButton:hover {\n  background-color: #cc0812;\n}\n\n.cancelButton {\n  padding: 0.75rem 1.5rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #e1e1e1;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.cancelButton:hover {\n  background-color: #f5f5f5;\n}\n\n/* Custom styles for Jodit editor */\n.editorWrapper :global(.jodit-toolbar-button) {\n  color: #000;\n}\n\n.editorWrapper :global(.jodit-toolbar-button:hover) {\n  color: #E50914;\n}\n\n.editorWrapper :global(.jodit-workplace) {\n  border: 1px solid #e1e1e1;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagesContainer": `PagesSettings_pagesContainer__eYBeL`,
	"header": `PagesSettings_header__7aGy3`,
	"tabContainer": `PagesSettings_tabContainer__SBthX`,
	"tabButton": `PagesSettings_tabButton__Mf0pA`,
	"activeTab": `PagesSettings_activeTab__C85L4`,
	"tabPanel": `PagesSettings_tabPanel__FLQJE`,
	"activePanel": `PagesSettings_activePanel__+TnBb`,
	"editorContainer": `PagesSettings_editorContainer__ZQ7Nk`,
	"editorLabel": `PagesSettings_editorLabel__0Zh-t`,
	"actionButtons": `PagesSettings_actionButtons__cKKre`,
	"saveButton": `PagesSettings_saveButton__8tzRL`,
	"cancelButton": `PagesSettings_cancelButton__wdd7Z`,
	"editorWrapper": `PagesSettings_editorWrapper__7jexn`
};
export default ___CSS_LOADER_EXPORT___;
